import React from "react";

import { Text, Image } from "@chakra-ui/react"; // Add this import statement
import { color } from "../../utils/theme";

const Title = ({ onClick, title }: { onClick: () => void; title: string }) => {
  return (
    <Text
      fontSize={[18, 18, 18, 16, 24, 26]}
      textAlign={"left"}
      // mr={[4, 4, 5, 5, 5, 10]}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"left"}
      alignContent={"flex-start"}
      cursor={"pointer"}
      onClick={() => {
        onClick();
      }}
      fontWeight={"normal"}
      color={color.primary}
      gap={5}
      alignItems={"center"}
      my={7}
    >
      <Image
        _hover={{ shadow: "md" }}
        src={require("../../assets/left-arrow.png")}
        w={"30px"}
        h={"30px"}
      />
      {title}
    </Text>
  );
};
export default Title;
